module.exports = __webpack_public_path__ + "img/lindsay-logo.96aad614.svg";